import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../../actions/TablaPedidoCamionesEnCaladoActions'
import { TablaPedidosBrutoView } from '../../components/TablaPedidosBrutoView'

function TablaPedidoCamionesParaBruto (props) {
  const { actualizarDatosParaMuiTable, roles } = props

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'BALANCEROCAMIONES' || roles === 'DESARROLLADOR' || roles === 'SUPERVISOR')
    actualizarDatosParaMuiTable(rol)
  }, [actualizarDatosParaMuiTable, roles])

  return <TablaPedidosBrutoView />
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const mapStateToProps = (state) => ({
  roles: state.auth.roles
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TablaPedidoCamionesParaBruto)
